import { useEffect, useRef } from "react";
import "./pioneer.scss";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import lottie from "lottie-web";
import { Link } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const Pioneer = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const elements = sectionRef.current.querySelectorAll(".animate");

    elements.forEach((el) => {
      gsap.fromTo(
        el,
        { opacity: 0, y: 400 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 120%", // Start animation when 80% of the element is in view
            toggleActions: "play reverse play reverse", // Repeat animation on scroll
          },
        }
      );
    });
  }, []);

  const container1 = useRef(null);
  const container2 = useRef(null);
  const container3 = useRef(null);

  useEffect(() => {
    const animation1 = lottie.loadAnimation({
      container: container1.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/assets/coininhand.json", // Replace with your JSON file path
    });

    const animation2 = lottie.loadAnimation({
      container: container2.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/assets/refresh.json",
    });

    const animation3 = lottie.loadAnimation({
      container: container3.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/assets/globe.json",
    });

    return () => {
      animation1.destroy();
      animation2.destroy();
      animation3.destroy();
    };
  }, []);
  return (
    <>
      <section className="pioneermain">
        <img
          src="/assets/roadmapassets/banner/pioneerleftimg.png"
          alt="pioneerleftimg"
          className="pioneerleftimg"
        />
        <div className="custom-container">
          <div className="pionnerinner" ref={sectionRef}>
            <div className="pioneerleft">
              <h2 className="lefthead animate">A pioneering payment system</h2>
              <p className="leftpara animate">
                TOMI creates the ever-sought-after bridge between instant
                messaging and money transfers. All with a set of high-end
                features that make the merging of these worlds possible.
              </p>
              <Link to="/chatandpay" className="leftbtn animate">Learn More</Link>
            </div>
            <div className="pioneerright">
              <div className="rightcard animate">
                <div className="innerright">
                  <h3 className="cardhead">
                    Shared <br /> <span className="bold">Payments</span>
                  </h3>
                  <p className="cardpara">
                    for when it’s time to collect the rent, gather funds for a
                    present or even invest in a business initiative.
                  </p>
                </div>
                <div ref={container1} className="svgwidthset" />
              </div>
              <div className="rightcard animate">
                <div className="innerright">
                  <h3 className="cardhead">
                    Simplified Crypto <br />{" "}
                    <span className="bold">Transactions</span>
                  </h3>
                  <p className="cardpara">
                    directly within the chat, with username-based domains or
                    DIDs and gasless transactions (coming soon)
                  </p>
                </div>
                <div ref={container2} className="svgwidthset" />
              </div>
              <div className="rightcard animate">
                <div className="innerright">
                  <h3 className="cardhead">
                    All in <br /> <span className="bold">one app</span>
                  </h3>
                  <p className="cardpara">
                    tomi’s reach goes way beyond chat payments, with ongoing
                    development of new features like mini dApps, storage, VPN
                    and many more.
                  </p>
                </div>
                <div ref={container3} className="svgwidthset thirdsvg" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Pioneer;
